import React, { useEffect, useState } from "react";
import { DEVICE_DETAILS } from "config";
import { useHistory } from "react-router-dom";
import { Autocomplete } from "@material-ui/lab";
import { BrowserRouter } from "react-router-dom";
import RouterConfig from "navigation/RouterConfig";
import Header from "components/Header";
import TestEnvironment from "components/TestEnvironment";
import  TranslationProvider  from "providers/TranslationProvider";
import { RCProvider } from "providers/";
import Refresh from "components/Refresh";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import {
  Card,
  CardContent,
  Button,
  IconButton,
  CircularProgress,
  Container,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  Radio,
  RadioGroup,
  Typography,
  TextField,
  Select,
  Checkbox,
  MenuItem,
  InputLabel,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@material-ui/core";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import CancelIcon from "@material-ui/icons/Cancel";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { IDEA_FORM_SUCCESS } from "navigation/CONSTANTS";
import { saveIdeaWVForm } from "../../services/wvForms";
import { SET_EMPTY } from "../../config";
import { uploadIdeaFiles, getFileUrl } from "services";
import { set } from "date-fns";
import { updateLang } from "i18n";
import { getUserDetails } from "services";
import { isEmptyObject } from "utils";

const KEY = "ideaForm";
const DISABLE_OBJECT = {
  name: false,
  email: false,
  jobRole: false,
  productDescription: false,
  country: false,
};


const useStyles = makeStyles((theme) => ({
  header: {
    border: `1px solid #dadce0`,
    wordWrap: "break-word",
    pageBreakInside: "avoid",
    background: "#fff",
    borderRadius: 8,
    borderTopWidth: 10,
    borderTopColor: theme.palette.primary.main,
    marginTop: 10,
  },
  root: {
    minWidth: "80%",
  },
  form: {
    "&>*": {
      marginBottom: 16,
    },
  },
  textField: {
    minWidth: "50%",
  },
  textArea: {
    width: "100%",
  },
}));

// const { t, i18n } = useTranslation();
const businessLineOptions = [
  { id: "1", value: "Consumer", label: "Consumer" },
  {
    id: "2",
    value: "Data Management",
    label: "Data Management",
  },
  { id: "3", value: "Entertainment Services", label: "Entertainment Services" },
  { id: "4", value: "Fine Arts", label: "Fine Arts" },
  {
    id: "5",
    value: "Digital Solutions",
    label: "Digital Solutions",
  },
  {
    id: "6",
    value: "ITAD",
    label: "ITAD",
  },
  { id: "7", value: "Records Management", label: "Records Management" },
  { id: "8", value: "Shred", label: "Shred" },
  { id: "9", value: "Transportation", label: "Transportation" },
  { id: "10", value: "Warehouse & Logistics", label: "Warehouse & Logistics" },
  { id: "11", value: "Other", label: "Other" },
];



const errorMessageObject = {
  empId: SET_EMPTY,
  empName: SET_EMPTY,
  empEmail: SET_EMPTY,
  empJobRole: SET_EMPTY,
  empProductDescription: SET_EMPTY,
  empCountry: SET_EMPTY,
  region: SET_EMPTY,
  behalf: SET_EMPTY,
  ideaOwner: SET_EMPTY,
  businessLine: SET_EMPTY,
  otherBusinessLine: SET_EMPTY,
  impact: SET_EMPTY,
  categories: SET_EMPTY,
  otherCategory: SET_EMPTY,
  description: SET_EMPTY,
  existprob: SET_EMPTY,
  solExistProb: SET_EMPTY,
  geography: SET_EMPTY,
  appliedlocally: SET_EMPTY,
  monthsRequired: SET_EMPTY,
  comments: SET_EMPTY,
};

const MAIL_FORMAT_RE = /^[A-Za-z0-9_.-]+\w*@ironmountain\.+(\w*\.?\w{2,7})+$/;


const fileNameDisplay = (fileName) => {
  if (fileName) {
    const periodIndex = fileName.lastIndexOf(".");
    const shortenedName = fileName.slice(0, periodIndex).slice(0, 40);
    const extention = fileName.slice(periodIndex);
    const fileNameNew = `${shortenedName}...${extention}`;
    return fileNameNew;
  }
};

const IdeaForm = () => {
  const history = useHistory();
  const theme = useTheme();
  const classes = useStyles();

  const [empId, setEmpId] = useState("");
  const [managerName,setManagerName] = useState("");
  const [managerEmail,setManagerEmail] = useState("");
  const [isBehalf, setIsBehalf] = useState(SET_EMPTY);
  const [currIdeaOwner, setCurrIdeaOwner] = useState("");
  const [ideaOwners, setIdeaOwners] = useState([]);
  const [businessLine, setBusinessLine] = useState([]);
  const [isOtherBusinessVisible, setOtherBusinessVisible] = useState(false);
  const [otherBusinessLine, setOtherBusinessLine] = useState("");
  const [empName, setEmpName] = useState("");
  const [maskedEmpName, setMaskedEmpName] = useState("");
  const [empEmail, setEmpEmail] = useState("");
  const [empEmailVisible, setEmpEmailVisible] = useState(true);
  const [empJobRole, setEmpJobRole] = useState("");
  const [empProductDescription, setEmpProductDescription] = useState("");
  const [empCountry, setEmpCountry] = useState("");
  const [empDetailsDisabled, setEmpDetailsDisabled] = useState(DISABLE_OBJECT);
  const [empRegion, setEmpRegion] = useState("");
  const [empExists, setEmpExists] = useState(false);
  const [impact, setImpact] = useState("");
  const [categoriesSelected, setCategoriesSelected] = useState([]);
  const [isOtherCategoryVisible, setIsOtherCategoryVisible] = useState(false);
  const [otherCategory, setOtherCategory] = useState("");
  const [description, setDescription] = useState("");
  const [isSolExistProb, setIsSolExistProb] = useState(SET_EMPTY);
  const [solExistProb, setSolExistProb] = useState("");
  const [isAppliedLocally, setIsAppliedLocally] = useState("");
  const [monthsRequired, setMonthsRequired] = useState("");
  const [comments, setComments] = useState("");
  const [geography, setGeography] = useState("");
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);
  const [processing, setProcessing] = useState(false);
  const [errorMessage, setErrorMessage] = useState(errorMessageObject);
  const [fetchedUser, setFetchedUser] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [isSubmitPressed, setIsSubmitPressed] = useState(false);
  const [categoriesOpen, setCategoriesOpen] = useState(false);
  const [businessOpen, setBusinessOpen] = useState(false);
  const [errorAlertDiag, setErrorAlertDiag] = useState(false);
  const { t, i18n } = useTranslation();
  const [empisActive,setEmpisActive]= useState(true);


  const regionOptions = [
    { value: "ASIAPAC", label: "ASIAPAC"  },
    { value: "Europe", label: "Europe"  },
    { value: "LATAM", label: "LATAM" },
    { value: "MENATSA", label: "MENATSA" },
    { value: "North America", label: "North America" },
    { value: "RCIS", label: "RCIS" },
  ];

  

  const geographyOptions = [
    { value: "Regional", label:  t("other.lblRegional")},
    { value: "Global", label:  t("other.lblGlobal") },
    { value: "Not Sure", label:  t("other.lblNotSure") },
  ];
  

  const categoriesOption = [
    { id: "1", value: "Automation", label:  t("other.lblAutomation") },
    { id: "2", value: "Chain of Custody", label:  t("other.lblChainofCustody") },
    {
      id: "3",
      value: "Cost Reduction",
      label:  t("other.lblCostReduction"),
    },
    { id: "4", value: "Customer Experience", label:  t("other.lblCustomerExperience") },
    { id: "5", value: "Employee Experience", label:  t("other.lblEmployeeExperience") },
    {
      id: "6",
      value: "Employee Training",
      label:  t("other.lblEmployeeTraining"),
    },
    {
      id: "7",
      value: "Environment Sustainability",
      label:  t("other.lblEnvironmentSustainability"),
    },
    { id: "8", value: "Equipment", label:  t("other.lblEquipment")},
    { id: "9", value: "Facility Improvement", label:  t("other.lblFacilityImprovement")},
    {
      id: "10",
      value: "Operational Excellence",
      label:  t("other.lblOperationalExcellence"),
    },
    {
      id: "11",
      value: "Performance Management",
      label:  t("other.lblPerformanceManagement"),
    },
    {
      id: "12",
      value: "Process Change/Improvement",
      label:  t("other.lblProcessChangeOrImprovement"),
    },
    {
      id: "13",
      value: "Revenue/Sales Opportunity",
      label:  t("other.lblRevenueOrSalesOpportunity"),
    },
    {
      id: "14",
      value: "Safety/Compliance/Risk",
      label:  t("other.lblSafetyOrComplianceOrRisk"),
    },
    {
      id: "15",
      value: "Standardization/Optimization",
      label:  t("other.lblStandardizationOrOptimization"),
    },
    { id: "16", value: "Systems Improvement", label:  t("other.lblSystemsImprovement") },
    {
      id: "17",
      value: "Tools/Technology",
      label:  t("other.lblToolsOrTechnology"),
    },
    { id: "18", value: "Other", label:  t("other.lblOther") },
  ];
  
  

  const getEmpDetails = async (empId) => {
    await getUserDetails(empId)
      .then((details) => {
        const empDetails = details.data();
        if (empDetails) {
          let firstName = empDetails.firstName;
          let lastName = empDetails.lastName;
          let managerLastName = empDetails?.managerLastName;
          let managerFirstName = empDetails?.managerFirstName;
          var regex =/\b(\w{1,3})(\w{2,}?)(\w?)\b/g;
          var regex1 =/\b(\w{1})(\w{2,}?)(\w?)\b/g;
          let maskedFirstName;
          let maskedSecondName;
          if(firstName) maskedFirstName= firstName.replace(
            regex,
            (_, first, middle, last) => `${first}${'*'.repeat(middle.length)}${'*'.repeat(last.length)}`
          );
          if(lastName) maskedSecondName = lastName.replace(
            regex1,
            (_, first, middle, last) => `${first}${'*'.repeat(middle.length)}${'*'.repeat(last.length)}`
          );
          setEmpName(`${firstName} ${lastName}`);
          setManagerEmail(empDetails.managerEmail ? empDetails.managerEmail : SET_EMPTY);
          setManagerName(`${managerFirstName} ${managerLastName}`)
          setMaskedEmpName(`${maskedFirstName} ${maskedSecondName}`)
          setEmpEmail(empDetails.email ? empDetails.email : SET_EMPTY);
          setEmpEmailVisible(empDetails.email ? false : true)
          setEmpJobRole(empDetails.jobRole ? empDetails.jobRole : SET_EMPTY);
          setEmpProductDescription(
            empDetails.productDescription
              ? empDetails.productDescription
              : SET_EMPTY
          );
          setEmpExists(true);
          setEmpCountry(empDetails.country ? empDetails.country : SET_EMPTY);
          const disableObject = {
            name: `${empDetails.firstName} ${empDetails.lastName}`
              ? true
              : false,
            email: empDetails.email ? true : false,
            jobRole: empDetails.jobRole ? true : false,
            productDescription: empDetails.productDescription ? true : false,
            country: empDetails.country ? true : false,
          };
          if(empDetails.isActiveWorker===true){
            setEmpisActive(true)
          }
          else{
            setEmpisActive(false)
            setEmpName(SET_EMPTY);
            setMaskedEmpName(SET_EMPTY)
            setEmpEmail(SET_EMPTY);
            setEmpEmailVisible(true);
            setEmpJobRole(SET_EMPTY);
            setEmpProductDescription(SET_EMPTY);
            setEmpCountry(SET_EMPTY);
            setEmpDetailsDisabled(DISABLE_OBJECT);
            setManagerEmail(SET_EMPTY);
            setManagerName(SET_EMPTY);
          }
          if (isSubmitPressed) {
            const errObject = {
              empName: disableObject.name ? "" : "Required",
              empEmail: disableObject.email ? "" : "Required",
              empJobRole: disableObject.jobRole ? "" : "Required",
              empProductDescription: disableObject.productDescription
                ? ""
                : "Required",
              empCountry: disableObject.country ? "" : "Required",
            };
            setErrorMessage((oldState) => ({
              ...oldState,
              ...errObject,
            }));
          }
          setEmpDetailsDisabled(disableObject);
          
        } else {
          setEmpName(SET_EMPTY);
          setEmpEmail(SET_EMPTY);
          setEmpEmailVisible(true);
          setMaskedEmpName(SET_EMPTY)
          setEmpJobRole(SET_EMPTY);
          setEmpProductDescription(SET_EMPTY);
          setEmpCountry(SET_EMPTY);
          setEmpDetailsDisabled(DISABLE_OBJECT);
          setEmpExists(false);
          setManagerEmail(SET_EMPTY);
          setManagerName(SET_EMPTY);
        }
      })
      .catch((error) => {
        setEmpName(SET_EMPTY);
        setMaskedEmpName(SET_EMPTY)
        setEmpEmail(SET_EMPTY);
        setEmpEmailVisible(true);
        setEmpJobRole(SET_EMPTY);
        setEmpProductDescription(SET_EMPTY);
        setEmpCountry(SET_EMPTY);
        setEmpDetailsDisabled(DISABLE_OBJECT);
        setEmpExists(false);
        setManagerEmail(SET_EMPTY);
        setManagerName(SET_EMPTY);
        console.log("Error in get Employee Details" + error);
      });
    setFetchedUser(true);
  };

  const handleEmpIdChange = async (event) => {
    const value = event.target.value;
    if (value.length < 8) {
      const lastCharacter = value.charAt(value.length - 1);
      const isNumber = !isNaN(lastCharacter - parseFloat(lastCharacter));
      if (isNumber || isEmptyObject(value)) {
        handleOnBlur(event);
        if (value.length > 5) {
            await getEmpDetails(value);
            setEmpId(value);
        } else {
          setEmpId(value);
          setEmpName(SET_EMPTY);
          setMaskedEmpName(SET_EMPTY)
          setEmpEmail(SET_EMPTY);
          setEmpEmailVisible(true);
          setEmpJobRole(SET_EMPTY);
          setEmpProductDescription(SET_EMPTY);
          setEmpCountry(SET_EMPTY);
          setEmpDetailsDisabled(DISABLE_OBJECT);
          setEmpExists(false);
          setManagerEmail(SET_EMPTY);
          setManagerName(SET_EMPTY);
          if (isSubmitPressed) {
            const errObject = {
              empName: "",
              empEmail: "",
              empJobRole: "",
              empProductDescription: "",
              empCountry: "",
            };
            setErrorMessage((oldState) => ({
              ...oldState,
              ...errObject,
            }));
          }
        }
      }
    }
  };

  const handleBehalfChange = (event) => {
    const value = event.target.value;
    handleOnBlur(event);
    setIsBehalf(value);
  };

  const handleIdeaOwnerChange = (event) => {
    const value = event.target.value;
    handleOnBlurIdeaOwners(event);
    setCurrIdeaOwner(value);
  };

  const onKeyDownIdeaOwner = (event) => {
    const key = event.keyCode;
    const value = event.target.value;
    if (key == 13 && !isEmptyObject(value.trim())) {
      handleOnBlurIdeaOwners();
      setIdeaOwners((oldState) => [...oldState, value.trim()]);
      setCurrIdeaOwner("");
    }
  };

  const handleIdeaOwnersButton = () => {
    if (!isEmptyObject(currIdeaOwner.trim())) {
      handleOnBlurIdeaOwners();
      setIdeaOwners((oldState) => [...oldState, currIdeaOwner.trim()]);
      setCurrIdeaOwner("");
    }
  };

  const handleOwnerDelete = (item, index) => {
    let arr = [...ideaOwners];
    arr.splice(index, 1);
    setIdeaOwners(arr);
  };

  const handleBusinessLineChange = (event, value) => {
    if (value) {
      const isOther = value.some((cat) => cat.value === "Other");
      if (isOther) {
        setOtherBusinessVisible(true);
      } else {
        setOtherBusinessVisible(false);
        setOtherBusinessLine(SET_EMPTY);
      }
      handleOnBlurBusiness(value);
      setBusinessLine(value);
    }
  };

  const handleOtherBusinessChange = (event) => {
    const value = event.target.value;
    handleOnBlur(event);
    setOtherBusinessLine(value);
  };

  const handleImpactChange = (event) => {
    const value = event.target.value;
    handleOnBlur(event);
    setImpact(value);
  };

  const handleCategoriesChange = (event, value) => {
    const isOther = value.some((cat) => cat.value === "Other");

    if (isOther) {
      setIsOtherCategoryVisible(true);
    } else {
      setIsOtherCategoryVisible(false);
      setOtherCategory(SET_EMPTY);
    }
    setCategoriesSelected(value);
    handleOnBlurCategories(value);
  };

  const handleOtherCategoryChange = (event) => {
    const value = event.target.value;
    handleOnBlur(event);
    setOtherCategory(value);
  };

  const handleDescriptionChange = (event) => {
    const value = event.target.value;
    handleOnBlur(event);
    setDescription(value);
  };

  const handleIsSolExistProbChange = (event) => {
    const value = event.target.value;
    handleOnBlur(event);
    setIsSolExistProb(value);
  };

  const handleSolExistProbChange = (event) => {
    const value = event.target.value;
    handleOnBlur(event);
    setSolExistProb(value);
  };

  const handleCommentsChange = (event) => {
    const value = event.target.value;
    handleOnBlur(event);
    setComments(value);
  };

  const handleNameChange = (event) => {
    const value = event.target.value;
    handleOnBlur(event);
    setEmpName(value);
  };
  const handleEmailChange = (event) => {
    const value = event.target.value;
    handleOnBlur(event);
    setEmpEmail(value);
  };
  const handleJobRoleChange = (event) => {
    const value = event.target.value;
    handleOnBlur(event);
    setEmpJobRole(value);
  };
  const handleProductDescriptionChange = (event) => {
    const value = event.target.value;
    handleOnBlur(event);
    setEmpProductDescription(value);
  };
  const handleCountryChange = (event) => {
    const value = event.target.value;
    handleOnBlur(event);
    setEmpCountry(value);
  };

  const handleRegionChange = (event) => {
    const value = event.target.value;
    handleOnBlur(event);
    setEmpRegion(value);
  };

  const handleGeographyChange = (event) => {
    const value = event.target.value;
    handleOnBlur(event);
    setGeography(value);
  };

  const handleProcessingOpen = () => {
    setProcessing(true);
  };

  const handleProcessingClose = () => {
    setProcessing(false);
  };

  const handleAppliedLocallyChange = (event) => {
    const value = event.target.value;
    handleOnBlur(event);
    setIsAppliedLocally(value);
  };

  const handleMonthsRequiredChange = (event) => {
    const value = event.target.value;
    const lastCharacter = value.charAt(value.length - 1);
    const isNumber = !isNaN(lastCharacter - parseFloat(lastCharacter));
    if (isNumber || isEmptyObject(value)) {
      handleOnBlur(event);
      setMonthsRequired(value);
    }
  };

  const validateEmail = (email) => {
    if (MAIL_FORMAT_RE.test(email)) {
      if (email.length - "@ironmountain".length !== -1) {
        //VALID
        return true;
      }
    }
  };

  const handleOnBlur = (event) => {
    const target = event.target;
    if (target.id) {
      if (
        !target.value ||
        target.value === null ||
        target.value.trim() === SET_EMPTY
      ) {
        setErrorMessage((oldState) => ({
          ...oldState,
          [target.id]: "Required",
        }));
      } else {
        setErrorMessage((oldState) => ({
          ...oldState,
          [target.id]: SET_EMPTY,
        }));
      }
    } else if (target.name) {
      if (
        target.value === undefined ||
        target.value === null ||
        target.value === SET_EMPTY
      ) {
        setErrorMessage((oldState) => ({
          ...oldState,
          [target.name]: "Required",
        }));
      } else {
        setErrorMessage((oldState) => ({
          ...oldState,
          [target.name]: SET_EMPTY,
        }));
      }
    }
  };

  const handleOnBlurIdeaOwners = (event) => {
    let value;
    if (event) {
      value = event.target.value;
    } else {
      value = currIdeaOwner;
    }

    if (isEmptyObject(ideaOwners) && value === SET_EMPTY) {
      setErrorMessage((oldState) => ({
        ...oldState,
        ideaOwner: "Required",
      }));
    } else {
      setErrorMessage((oldState) => ({
        ...oldState,
        ideaOwner: SET_EMPTY,
      }));
    }
  };

  const handleOnBlurCategories = (value) => {
    if (isEmptyObject(value)) {
      setErrorMessage((oldState) => ({
        ...oldState,
        categories: "Required",
      }));
    } else {
      setErrorMessage((oldState) => ({
        ...oldState,
        categories: SET_EMPTY,
      }));
    }
  };

  const handleOnBlurBusiness = (value) => {
    if (isEmptyObject(value)) {
      setErrorMessage((oldState) => ({
        ...oldState,
        businessLine: "Required",
      }));
    } else {
      setErrorMessage((oldState) => ({
        ...oldState,
        businessLine: SET_EMPTY,
      }));
    }
  };

  const checkErrors = () => {
    const errorMessages = {
      empId: SET_EMPTY,
      empName: SET_EMPTY,
      empEmail: SET_EMPTY,
      empJobRole: SET_EMPTY,
      empProductDescription: SET_EMPTY,
      empCountry: SET_EMPTY,
      region: SET_EMPTY,
      behalf: SET_EMPTY,
      ideaOwner: SET_EMPTY,
      businessLine: SET_EMPTY,
      otherBusinessLine: SET_EMPTY,
      impact: SET_EMPTY,
      categories: SET_EMPTY,
      otherCategory: SET_EMPTY,
      description: SET_EMPTY,
      existprob: SET_EMPTY,
      solExistProb: SET_EMPTY,
      geography: SET_EMPTY,
      appliedlocally: SET_EMPTY,
      monthsRequired: SET_EMPTY,
      comments: SET_EMPTY,
    };
    const REQUIRED = "Required";

    if (empId.trim() === SET_EMPTY) {
      errorMessages.empId = REQUIRED;
    } else if (empId.trim().length < 6) {
      errorMessages.empId = t("other.lblMinimumSixDigitsRequired");
    } else {
      errorMessages.empId = SET_EMPTY;
    }

    if (empName.trim() === SET_EMPTY) {
      errorMessages.empName = REQUIRED;
    } else {
      errorMessages.empName = SET_EMPTY;
    }

    if (empEmail.trim() === SET_EMPTY) {
      errorMessages.empEmail = REQUIRED;
    } else if (!validateEmail(empEmail.trim())) {
      errorMessages.empEmail = "Enter Iron Mountain ID";
    } else {
      errorMessages.empEmail = SET_EMPTY;
    }

    if (empJobRole.trim() === SET_EMPTY) {
      errorMessages.empJobRole = REQUIRED;
    } else {
      errorMessages.empJobRole = SET_EMPTY;
    }

    if (empProductDescription.trim() === SET_EMPTY) {
      errorMessages.empProductDescription = REQUIRED;
    } else {
      errorMessages.empProductDescription = SET_EMPTY;
    }

    if (empCountry.trim() === SET_EMPTY) {
      errorMessages.empCountry = REQUIRED;
    } else {
      errorMessages.empCountry = SET_EMPTY;
    }

    if (empRegion.trim() === SET_EMPTY) {
      errorMessages.region = REQUIRED;
    } else {
      errorMessages.region = SET_EMPTY;
    }

    if (isBehalf === SET_EMPTY) {
      errorMessages.behalf = REQUIRED;
    } else {
      errorMessages.behalf = SET_EMPTY;
    }

    if (isBehalf && isEmptyObject(ideaOwners)) {
      errorMessages.ideaOwner = REQUIRED;
    } else {
      errorMessages.ideaOwner = SET_EMPTY;
    }

    if (isEmptyObject(businessLine)) {
      errorMessages.businessLine = REQUIRED;
    } else {
      errorMessages.businessLine = SET_EMPTY;
    }

    if (isOtherBusinessVisible && otherBusinessLine.trim() === SET_EMPTY) {
      errorMessages.otherBusinessLine = REQUIRED;
    } else {
      errorMessages.otherBusinessLine = SET_EMPTY;
    }

    if (impact.trim() === SET_EMPTY) {
      errorMessages.impact = REQUIRED;
    } else {
      errorMessages.impact = SET_EMPTY;
    }

    if (isEmptyObject(categoriesSelected)) {
      errorMessages.categories = REQUIRED;
    } else {
      errorMessages.categories = SET_EMPTY;
    }

    if (isOtherCategoryVisible && otherCategory.trim() === SET_EMPTY) {
      errorMessages.otherCategory = REQUIRED;
    } else {
      errorMessages.otherCategory = SET_EMPTY;
    }

    if (description.trim() === SET_EMPTY) {
      errorMessages.description = REQUIRED;
    } else {
      errorMessages.description = SET_EMPTY;
    }

    if (isSolExistProb === SET_EMPTY) {
      errorMessages.existprob = REQUIRED;
    } else {
      errorMessages.existprob = SET_EMPTY;
    }

    if (isSolExistProb && solExistProb.trim() === SET_EMPTY) {
      errorMessages.solExistProb = REQUIRED;
    } else {
      errorMessages.solExistProb = SET_EMPTY;
    }

    if (geography === SET_EMPTY) {
      errorMessages.geography = REQUIRED;
    } else {
      errorMessages.geography = SET_EMPTY;
    }

    if (isAppliedLocally === SET_EMPTY) {
      errorMessages.appliedlocally = REQUIRED;
    } else {
      errorMessages.appliedlocally = SET_EMPTY;
    }

    if (isAppliedLocally && monthsRequired.trim() === SET_EMPTY) {
      errorMessages.monthsRequired = REQUIRED;
    } else {
      errorMessages.monthsRequired = SET_EMPTY;
    }

    if (comments.trim() === SET_EMPTY) {
      errorMessages.comments = REQUIRED;
    } else {
      errorMessages.comments = SET_EMPTY;
    }
    setErrorMessage(errorMessages);
  };

  const handleFileChoose = (event) => {
    const files = event.target.files;
    const fileArray = [];
    for (let i = 0; i < files.length; i++) {
      fileArray.push(files[i]);
    }

    setFileList((oldState) => oldState.concat(fileArray));
  };

  const hadleFileDelete = (index) => {
    let arr = [...fileList];
    arr.splice(index, 1);
    setFileList(arr);
  };

  const onClear = () => {
    setIsSubmitPressed(false);
    setEmpId(SET_EMPTY);
    setEmpName(SET_EMPTY);
    setMaskedEmpName(SET_EMPTY)
    setEmpEmail(SET_EMPTY);
    setEmpEmailVisible(true);
    setEmpJobRole(SET_EMPTY);
    setEmpProductDescription(SET_EMPTY);
    setEmpCountry(SET_EMPTY);
    setEmpRegion(SET_EMPTY);
    setIsBehalf(SET_EMPTY);
    setCurrIdeaOwner(SET_EMPTY);
    setIdeaOwners([]);
    setBusinessLine([]);
    setOtherBusinessVisible(false);
    setOtherBusinessLine(SET_EMPTY);
    setImpact(SET_EMPTY);
    setCategoriesSelected([]);
    setIsOtherCategoryVisible(false);
    setOtherCategory(SET_EMPTY);
    setDescription(SET_EMPTY);
    setIsSolExistProb(SET_EMPTY);
    setSolExistProb(SET_EMPTY);
    setGeography(SET_EMPTY);
    setComments(SET_EMPTY);
    setEmpDetailsDisabled(DISABLE_OBJECT);
    setIsAppliedLocally(SET_EMPTY);
    setMonthsRequired(SET_EMPTY);
    // setFileList([]);
    setErrorMessage(errorMessageObject);
    setManagerEmail(SET_EMPTY);
    setManagerName(SET_EMPTY);
  };

  const onSubmit = async () => {
    checkErrors();
    setIsSubmitPressed(true);
    if (!isSubmitDisabled) {
      let categoriesToUpload = categoriesSelected.map((cat) => cat.value);
      let businessLineToUpload = businessLine.map((bus) => bus.value);

      if (isOtherCategoryVisible) {
        categoriesToUpload.push(otherCategory.trim());
        categoriesToUpload = categoriesToUpload.filter(
          (cat) => cat !== "Other"
        );
      }

      if (isOtherBusinessVisible) {
        businessLineToUpload.push(otherBusinessLine.trim());
        businessLineToUpload = businessLineToUpload.filter(
          (cat) => cat !== "Other"
        );
      }

      let form = {
        key: KEY,
        empId: empId.trim(),
        empName: empName.trim(),
        email: empEmail.trim(),
        jobRole: empJobRole.trim(),
        productDescription: empProductDescription.trim(),
        region: empRegion.trim(),
        country: empCountry.trim(),
        ideaOwner: isBehalf ? ideaOwners : empName.trim(),
        businessLine: businessLineToUpload,
        impact: impact,
        categories: categoriesToUpload,
        description: description.trim(),
        solExistingProblem: isSolExistProb ? "Yes" : "No",
        missionCriticalProblem: isSolExistProb
          ? solExistProb.trim()
          : SET_EMPTY,
        geography: geography,
        deployedLocally: isAppliedLocally ? "Yes" : "No",
        deploymentPeriod: isAppliedLocally ? parseFloat(monthsRequired) : 0,
        comments: comments.trim(),
        deviceType: DEVICE_DETAILS.deviceType,
        managerName,
        managerEmail
      };
      handleProcessingOpen();
      try {
        let filePathArray = await uploadIdeaFiles(fileList, empId);
        console.log("File paths for the uploaded files are  ", filePathArray);
        let urlArray = await getFileUrl(filePathArray);
        console.log("File urls for the uploaded files are ", urlArray);
        form.filePaths = urlArray;
        let ideaFormID = await saveIdeaWVForm(form);
        console.log(`
      globalOpsSurvey-form
      globalOpsSurveyFormID is ${ideaFormID}
      `);
        handleProcessingClose();
        history.push(IDEA_FORM_SUCCESS);
      } catch (error) {
        console.log(`
      globalOpsSurvey-form 
      error is ${error}
     `);
    }
    } else {
      setErrorAlertDiag(true);
    }
  };
  const {version}=useSelector((state)=>state.translation.i18n)
  if (version && version>1) {
    updateLang();
  }
  useEffect(() => {
    const header = document.querySelector("#header-bar");
    const testEnv = document.querySelector(".imtime-testEnvironment");
    if (header) header.style.display = "none";
    if (testEnv) testEnv.style.display = "none";
  }, []);

  useEffect(() => {
    if (
      empId.trim().length < 6 ||
      empName.trim() === SET_EMPTY ||
      empEmail.trim() === SET_EMPTY ||
      !validateEmail(empEmail.trim()) ||
      empJobRole.trim() === SET_EMPTY ||
      empProductDescription.trim() === SET_EMPTY ||
      empCountry.trim() === SET_EMPTY ||
      empRegion.trim() === SET_EMPTY ||
      isBehalf === SET_EMPTY ||
      (isBehalf && isEmptyObject(ideaOwners)) ||
      isEmptyObject(businessLine) ||
      (isOtherBusinessVisible && otherBusinessLine.trim() === SET_EMPTY) ||
      impact.trim() === SET_EMPTY ||
      isEmptyObject(categoriesSelected) ||
      (isOtherCategoryVisible && otherCategory.trim() === SET_EMPTY) ||
      description.trim() === SET_EMPTY ||
      isSolExistProb === SET_EMPTY ||
      (isSolExistProb && solExistProb.trim() === SET_EMPTY) ||
      geography === SET_EMPTY ||
      (isAppliedLocally && monthsRequired.trim() === SET_EMPTY) ||
      comments.trim() === SET_EMPTY
      // fileList.length === 0
    ) {
      setIsSubmitDisabled(true);
    } else {
      setIsSubmitDisabled(false);
    }
  }, [
    empId,
    empName,
    empEmail,
    empJobRole,
    empProductDescription,
    empCountry,
    empRegion,
    isBehalf,
    isBehalf,
    ideaOwners,
    businessLine,
    isOtherBusinessVisible,
    otherBusinessLine,
    impact,
    categoriesSelected,
    isOtherCategoryVisible,
    otherCategory,
    description,
    isSolExistProb,
    isSolExistProb,
    solExistProb,
    geography,
    isAppliedLocally,
    monthsRequired,
    comments,
    // isSubmitPressed,
  ]);
useEffect(() => {
    document.title = 'GOC Innovation Survey';
  });
  return (
    <>
      <Container maxWidth="sm">
        <form className={classes.form} noValidate autoComplete="off">
        <Grid container direction="column" alignItems="stretch" spacing={2}>
            <Grid item>
            <TranslationProvider />                         
                <Header  isLogoLinkDisabled={DEVICE_DETAILS.deviceType === "mobile" ? true : false}/>  
            </Grid>
         </Grid>   
          <Grid container direction="column" alignItems="stretch" spacing={2}>
            <Grid item>
              <Card className={classes.header}>
                <CardContent>
                  <Typography variant="h6" gutterBottom color="textPrimary">                    
                    {t("other.lblGlobalOperations")}
                  </Typography>
                  <Typography variant="body2" gutterBottom>
                  {t("other.lblGlobalOpsHeading")}
                  </Typography>
                  <Typography variant="body2" gutterBottom>
                  {t("other.lblGlobalOpsHeadingTwo")}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>

            <Grid item>
              <Card className={classes.root}>
                <CardContent>
                  <Typography
                    variant="subtitle1"
                    gutterBottom
                    color="textPrimary"
                  >
                    {t("other.lblYourWorkerId")}
                    <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <TextField
                    value={empId}
                    onChange={handleEmpIdChange}
                    id="empId"
                    label={t("other.lblEnterYourWorkerId")}
                    className={classes.textField}
                    // onBlur={handleOnBlur}
                    error={!!errorMessage.empId}
                    helperText={
                      !!errorMessage.empId
                        ? errorMessage.empId
                        : empId.trim().length < 6
                        ? t("other.lblMinimumSixDigitsRequired")
                        : ""
                    }
                  />
                  {!empExists && empId.length > 5 ?(
                    <Typography
                      variant="subtitle2"
                      gutterBottom
                      color="textPrimary"
                      style={{color:"red"}}
                    >
                      {t("pgHome.errNotFoundWorker")}                   
                    </Typography>
                  ): !empisActive  && empId.length > 5 &&
                  (
                    <Typography
                    variant="subtitle2"
                    gutterBottom
                    color="textPrimary"
                    style={{color:"red"}}
                  >
                    {t("pgHome.errInactiveWorker")}
                  </Typography>	
                  )}
                </CardContent>
              </Card>
            </Grid>

            <Grid item>
              <Card className={classes.root}>
                <CardContent>
                  <Typography
                    variant="subtitle1"
                    gutterBottom
                    color="textPrimary"
                  >
                    {t("other.lblYourDetails")}
                    <span style={{ color: "red" }}>*</span>
                  </Typography>
                  
                  {/*  */}
                  <Grid
                    container
                    direction="column"
                    alignItems="stretch"
                    spacing={1}
                  >
                    <Grid item>
                      <TextField
                        value={maskedEmpName?maskedEmpName:empName}
                        onChange={handleNameChange}
                        disabled={empDetailsDisabled.name}
                        id="empName"
                        label={t("pgHome.lblName")}
                        className={classes.textField}
                        // onBlur={handleOnBlur}
                        error={!!errorMessage.empName}
                        helperText={errorMessage.empName}
                      />
                    </Grid>
                    {empEmailVisible && (
                        <Grid item>
                        <TextField
                          value={empEmail}
                          onChange={handleEmailChange}
                          disabled={empDetailsDisabled.email}
                          id="empEmail"
                          label={t("pgReview.tableHeads.email")}
                          className={classes.textField}
                          // onBlur={handleOnBlur}
                          error={!!errorMessage.empEmail}
                          helperText={errorMessage.empEmail}
                        />
                        </Grid>
                    )}
                    <Grid item>
                      <TextField
                        value={empJobRole}
                        onChange={handleJobRoleChange}
                        disabled={empDetailsDisabled.jobRole}
                        id="empJobRole"
                        label={t("other.jobRole")}
                        className={classes.textField}
                        // onBlur={handleOnBlur}
                        error={!!errorMessage.empJobRole}
                        helperText={errorMessage.empJobRole}
                      />
                    </Grid>
                    <Grid item>
                      <TextField
                        value={empProductDescription}
                        onChange={handleProductDescriptionChange}
                        disabled={empDetailsDisabled.productDescription}
                        id="empProductDescription"
                        label={t("other.lblProductDescription")}
                        className={classes.textField}
                        // onBlur={handleOnBlur}
                        error={!!errorMessage.empProductDescription}
                        helperText={errorMessage.empProductDescription}
                      />
                    </Grid>
                    <Grid item>
                      <TextField
                        value={empCountry}
                        onChange={handleCountryChange}
                        disabled={empDetailsDisabled.country}
                        id="empCountry"
                        label={t("other.tlCountry")}
                        className={classes.textField}
                        // onBlur={handleOnBlur}
                        error={!!errorMessage.empCountry}
                        helperText={errorMessage.empCountry}
                      />
                    </Grid>
                  </Grid>
                  {/*  */}
                </CardContent>
              </Card>
            </Grid>

            <Grid item>
              <Card className={classes.root}>
                <CardContent>
                  <Typography
                    variant="subtitle1"
                    gutterBottom
                    color="textPrimary"
                  >
                    {t("other.lblYourRegion")}
                    <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <FormControl variant="outlined">
                    <InputLabel id="region-label">{t("other.lblChoose")}</InputLabel>
                    <Select
                      labelId="region-label"
                      id="region"
                      name="region"
                      style={{ width: 260 }}
                      label={t("other.lblChoose")}
                      className={classes.textField}
                      value={empRegion}
                      onChange={handleRegionChange}
                      // onBlur={handleOnBlur}
                      error={!!errorMessage.region}
                      helperText={errorMessage.region}
                    >
                      {regionOptions.map((region) => (
                        <MenuItem value={region.value}>{region.label}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </CardContent>
              </Card>
            </Grid>

            <Grid item>
              <Card className={classes.root}>
                <CardContent>
                  <Typography
                    variant="subtitle1"
                    gutterBottom
                    color="textPrimary"
                  >
                    {t("other.lblQueSubmitIdea")}                    
                    <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <Grid
                    container
                    direction="column"
                    alignItems="stretch"
                    spacing={1}
                  >
                    <Grid item>
                      <FormControl variant="outlined">
                        <InputLabel id="behalf-label">{t("other.lblChoose")}</InputLabel>
                        <Select
                          labelId="behalf-label"
                          id="behalf"
                          name="behalf"
                          style={{ width: 260 }}
                          label={t("other.lblChoose")}
                          className={classes.textField}
                          value={isBehalf}
                          onChange={handleBehalfChange}
                          // onBlur={handleOnBlur}
                          error={!!errorMessage.behalf}
                          helperText={errorMessage.behalf}
                        >
                          <MenuItem value={true}>{t("pgReview.btnYes")}</MenuItem>
                          <MenuItem value={false}>{t("pgReview.btnNo")}</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    {isBehalf && (
                      <Grid item>
                        <Typography
                          variant="subtitle1"
                          gutterBottom
                          color="textPrimary"
                        >
                          {t("other.lblProvideEmployees")}
                          <span style={{ color: "red" }}>*</span>
                        </Typography>
                        <Grid
                          container
                          direction="column"
                          alignItems="stretch"
                          spacing={1}
                        >
                          <Grid item>
                            {ideaOwners.map((item, index) => (
                              <Chip
                                key={index}
                                size="small"
                                onDelete={() => handleOwnerDelete(item, index)}
                                label={item}
                              />
                            ))}
                          </Grid>

                          <Grid
                            container
                            item
                            direction="row"
                            alignItems="center"
                            justifyContent="flex-start"
                            spacing={1}
                          >
                            <Grid item>
                              <TextField
                                value={currIdeaOwner}
                                onChange={handleIdeaOwnerChange}
                                onKeyDown={onKeyDownIdeaOwner}
                                id="ideaOwner"
                                label={t("other.lblIdeaOwnerName")}
                                className={classes.textField}
                                // onBlur={handleOnBlurIdeaOwners}
                                error={!!errorMessage.ideaOwner}
                                helperText={errorMessage.ideaOwner}
                              />
                            </Grid>
                            <Grid item>
                              <IconButton
                                variant="contained"
                                color="primary"
                                onClick={handleIdeaOwnersButton}
                                disabled={currIdeaOwner === SET_EMPTY}
                              >
                                <ArrowForwardIcon />
                              </IconButton>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    )}
                  </Grid>
                </CardContent>
              </Card>
            </Grid>

            <Grid item>
              <Card className={classes.root}>
                <CardContent>
                  <Typography
                    variant="subtitle1"
                    gutterBottom
                    color="textPrimary"
                  >
                    {t("other.lblBusinessLine")}
                    <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <Grid
                    container
                    direction="column"
                    alignItems="stretch"
                    spacing={1}
                  >
                    <Grid item>
                      <Autocomplete
                        multiple
                        id="businessLine"
                        type="dropdown"
                        open={businessOpen}
                        onOpen={() => setBusinessOpen(true)}
                        onClose={() => {}}
                        style={{ width: 260 }}
                        className={classes.textField}
                        options={businessLineOptions}
                        getOptionLabel={(option) => option.label}
                        value={businessLine}
                        onChange={handleBusinessLineChange}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            error={!!errorMessage.businessLine}
                            helperText={errorMessage.businessLine}
                            label={t("other.lblSelectBusinessLine")}
                          />
                        )}
                        onBlur={() => setBusinessOpen(false)}
                      />
                    </Grid>
                    <Grid item>
                      {isOtherBusinessVisible && (
                        <TextField
                          id="otherBusinessLine"
                          label="Other"
                          className={classes.textField}
                          value={otherBusinessLine}
                          onChange={handleOtherBusinessChange}
                          // onBlur={handleOnBlur}
                          error={!!errorMessage.otherBusinessLine}
                          helperText={errorMessage.otherBusinessLine}
                        />
                      )}
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>

            <Grid item>
              <Card className={classes.root}>
                <CardContent>
                  <Typography
                    variant="subtitle1"
                    gutterBottom
                    color="textPrimary"
                  >
                    {t("other.lblIdeaImpact")}
                    <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <FormControl variant="outlined">
                    <InputLabel id="impact-label">{t("other.lblChoose")}</InputLabel>
                    <Select
                      labelId="impact-label"
                      id="impact"
                      name="impact"
                      style={{ width: 260 }}
                      label={t("other.lblChoose")}
                      className={classes.textField}
                      value={impact}
                      onChange={handleImpactChange}
                      // onBlur={handleOnBlur}
                      error={!!errorMessage.impact}
                      helperText={errorMessage.impact}
                    >
                      <MenuItem value={"External Customer"}>
                        {t("other.lblExternalCustomer")}
                      </MenuItem>
                      <MenuItem value={"Internal Customer"}>
                        {t("other.lblInternalCustomer")}
                      </MenuItem>
                      <MenuItem value={"External and Internal Customer"}>
                        {t("other.lblBoth")}
                      </MenuItem>
                    </Select>
                  </FormControl>
                </CardContent>
              </Card>
            </Grid>

            <Grid item>
              <Card className={classes.root}>
                <CardContent>
                  <Typography
                    variant="subtitle1"
                    gutterBottom
                    color="textPrimary"
                  >
                    {t("other.lblQueCategory")}                    
                    <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <Grid
                    container
                    direction="column"
                    alignItems="stretch"
                    spacing={1}
                  >
                    <Grid item>
                      <Autocomplete
                        id="categories"
                        type="dropdown"
                        open={categoriesOpen}
                        onOpen={() => setCategoriesOpen(true)}
                        onClose={() => {}}
                        multiple
                        style={{ width: 260 }}
                        className={classes.textField}
                        options={categoriesOption}
                        getOptionLabel={(option) => option.label}
                        value={categoriesSelected}
                        onChange={handleCategoriesChange}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            error={
                              !!errorMessage.categories &&
                              isEmptyObject(categoriesSelected)
                            }
                            helperText={
                              !!errorMessage.categories &&
                              isEmptyObject(categoriesSelected)
                                ? "Required"
                                : ""
                            }
                            label={t("other.lblSelectAllThatApply")}
                          />
                        )}
                        onBlur={() => setCategoriesOpen(false)}
                      />
                    </Grid>
                    <Grid item>
                      {isOtherCategoryVisible && (
                        <TextField
                          id="otherCategory"
                          label="Other"
                          className={classes.textField}
                          value={otherCategory}
                          onChange={handleOtherCategoryChange}
                          // onBlur={handleOnBlur}
                          error={!!errorMessage.otherCategory}
                          helperText={errorMessage.otherCategory}
                        />
                      )}
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>

            <Grid item>
              <Card className={classes.root}>
                <CardContent>
                  <Typography
                    variant="subtitle1"
                    gutterBottom
                    color="textPrimary"
                  >
                    {t("other.lblIdeaDescription")}                    
                    <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <TextField
                    value={description}
                    onChange={handleDescriptionChange}
                    id="description"
                    label={t("other.lblDescription")} 
                    className={classes.textArea}
                    multiline
                    // onBlur={handleOnBlur}
                    error={!!errorMessage.description}
                    helperText={errorMessage.description}
                  />
                </CardContent>
              </Card>
            </Grid>

            <Grid item>
              <Card className={classes.root}>
                <CardContent>
                  <Typography
                    variant="subtitle1"
                    gutterBottom
                    color="textPrimary"
                  >
                    {t("other.lblUrgentIssue")}                    
                    <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <FormControl variant="outlined">
                    <InputLabel id="exist-prob-label">{t("other.lblChoose")}</InputLabel>
                    <Select
                      labelId="exist-prob-label"
                      id="exist-prob"
                      name="existprob"
                      style={{ width: 260 }}
                      label={t("other.lblChoose")}
                      className={classes.textField}
                      value={isSolExistProb}
                      onChange={handleIsSolExistProbChange}
                      // onBlur={handleOnBlur}
                      error={!!errorMessage.existprob}
                      helperText={errorMessage.existprob}
                    >
                      <MenuItem value={true}>{t("pgReview.btnYes")}</MenuItem>
                      <MenuItem value={false}>{t("pgReview.btnNo")}</MenuItem>
                    </Select>
                    {isSolExistProb && (
                      <>
                        <Typography
                          variant="subtitle1"
                          gutterBottom
                          color="textPrimary"
                        >
                          {t("other.lblShortSummaryIssue")}                          
                          <span style={{ color: "red" }}>*</span>
                        </Typography>
                        <TextField
                          value={solExistProb}
                          onChange={handleSolExistProbChange}
                          id="solExistProb"
                          label={t("other.lblEnter")}
                          className={classes.textArea}
                          multiline
                          // onBlur={handleOnBlur}
                          error={!!errorMessage.solExistProb}
                          helperText={errorMessage.solExistProb}
                        />
                      </>
                    )}
                  </FormControl>
                </CardContent>
              </Card>
            </Grid>

            <Grid item>
              <Card className={classes.root}>
                <CardContent>
                  <Typography
                    variant="subtitle1"
                    gutterBottom
                    color="textPrimary"
                  >
                    {t("other.lblRegionGlobally")}                                        
                    <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <FormControl variant="outlined">
                    <InputLabel id="geography-label">{t("other.lblChoose")}</InputLabel>
                    <Select
                      labelId="geography-label"
                      id="geography"
                      name="geography"
                      style={{ width: 260 }}
                      label={t("other.lblChoose")}
                      className={classes.textField}
                      value={geography}
                      onChange={handleGeographyChange}
                      // onBlur={handleOnBlur}
                      error={!!errorMessage.geography}
                      helperText={errorMessage.geography}
                    >
                      {geographyOptions.map((geography) => (
                        <MenuItem value={geography.value}>
                          {geography.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </CardContent>
              </Card>
            </Grid>

            <Grid item>
              <Card className={classes.root}>
                <CardContent>
                  <Typography
                    variant="subtitle1"
                    gutterBottom
                    color="textPrimary"
                  >
                    {t("other.lblDeployLocally")}                    
                    <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <FormControl variant="outlined">
                    <InputLabel id="applied-locally-label">{t("other.lblChoose")}</InputLabel>
                    <Select
                      labelId="applied-locally-label"
                      id="applied-locally"
                      name="appliedlocally"
                      style={{ width: 260 }}
                      label={t("other.lblChoose")}
                      className={classes.textField}
                      value={isAppliedLocally}
                      onChange={handleAppliedLocallyChange}
                      // onBlur={handleOnBlur}
                      error={!!errorMessage.appliedlocally}
                      helperText={errorMessage.appliedlocally}
                    >
                      <MenuItem value={true}>{t("pgReview.btnYes")}</MenuItem>
                      <MenuItem value={false}>{t("pgReview.btnNo")}</MenuItem>
                    </Select>
                    {isAppliedLocally && (
                      <>
                        <Typography
                          variant="subtitle1"
                          gutterBottom
                          color="textPrimary"
                        >
                          {t("other.lblHowManyMonths")}                          
                          <span style={{ color: "red" }}>*</span>
                        </Typography>
                        <TextField
                          value={monthsRequired}
                          onChange={handleMonthsRequiredChange}
                          id="monthsRequired"
                          label={t("other.lblEnter")}
                          className={classes.textArea}
                          multiline
                          // onBlur={handleOnBlur}
                          error={!!errorMessage.monthsRequired}
                          helperText={errorMessage.monthsRequired}
                        />
                      </>
                    )}
                  </FormControl>
                </CardContent>
              </Card>
            </Grid>

            <Grid item>
              <Card className={classes.root}>
                <CardContent>
                  <Typography
                    variant="subtitle1"
                    gutterBottom
                    color="textPrimary"
                  >
                    {t("other.lblAdditionalComments")}                    
                    <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <TextField
                    value={comments}
                    onChange={handleCommentsChange}
                    id="comments"
                    label={t("other.lblComments")} 
                    className={classes.textArea}
                    multiline
                    // onBlur={handleOnBlur}
                    error={!!errorMessage.comments}
                    helperText={errorMessage.comments}
                  />
                </CardContent>
              </Card>
            </Grid>

            {DEVICE_DETAILS.deviceType === "Desktop Web Browser" && (
              <Grid item>
                <Card className={classes.root}>
                  <CardContent>
                    <Typography
                      variant="subtitle1"
                      gutterBottom
                      color="textPrimary"
                    >
                      {t("other.lblUploadFiles")}                      
                      {/* <span style={{ color: "red" }}>*</span> */}
                    </Typography>
                    <div>
                      <label htmlFor="btn-upload">
                        <input
                          id="btn-upload"
                          name="btn-upload"
                          multiple
                          style={{ display: "none" }}
                          type="file"
                          // accept=".csv, text/csv"
                          onChange={handleFileChoose}
                        />
                        <Button
                          className="btn-choose"
                          variant="outlined"
                          component="span"
                        >
                          {t("pgUploadCwk.chooseFile")}                          
                        </Button>
                      </label>
                      {fileList.map((file, index) => (
                        <Grid
                          container
                          direction="row"
                          justify="flex-start"
                          alignItems="center"
                        >
                          <Grid item>{fileNameDisplay(file.name)}</Grid>
                          <Grid item>
                            <IconButton
                              variant="contained"
                              color="primary"
                              onClick={(event) => {
                                hadleFileDelete(index);
                              }}
                            >
                              <CancelIcon />
                            </IconButton>
                          </Grid>
                        </Grid>
                      ))}
                    </div>
                  </CardContent>
                </Card>
              </Grid>
            )}

            <Grid item>
              <Grid
                container
                direction="row"
                justify="space-between"
                spacing={2}
              >
                <Grid item>
                  <Button
                    type="Button"
                    variant="text"
                    color="secondary"
                    onClick={onClear}
                  >
                    {t("other.lblClearForm")}                    
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={onSubmit}
                    disabled={ !empExists && empId.length > 5 || !empisActive }
                  >
                    {t("pgHome.btEmpId")}                    
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </form>
      </Container>
      <Dialog
        open={processing}
        onClose={handleProcessingClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        disableBackdropClick={true}
      >
        <DialogTitle id="alert-dialog-title">{t("other.lblSubmitting")} </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
          {t("other.lblPleaseWaitToSubmt")}   <br /> <br />
            <Grid container justify="center">
              <Grid item>
                <CircularProgress />
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
      </Dialog>
      <Dialog
        open={errorAlertDiag}
        onClose={() => {
          setErrorAlertDiag(false);
        }}
        aria-labelledby="error-dialog-title"
        aria-describedby="error-dialog-description"
        disableBackdropClick={true}
      >
        <DialogTitle id="error-dialog-title"> {t("other.tlError")}</DialogTitle>
        <DialogContent>
          <DialogContentText id="error-dialog-description">
          {t("other.lblPleaseFillAllFields")}  <br /> <br />
             <Grid container justify="flex-end">
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  style={{ width: 90 }}
                  onClick={() => {
                    setErrorAlertDiag(false);
                  }}
                >
                 {t("pgPunch.btnOK")} 
                </Button>
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default IdeaForm;
